 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Admission":"Admission","Applicant":"Applicant","DataApp":"DataApp","Employee":"Employee","Exam":"Exam","ForgetPassword":"ForgetPassword","Mail":"Mail","MyApplication":"MyApplication","NotFound":"NotFound","Profile":"Profile","Tasks":"Tasks","Trems":"Trems","Wallet":"Wallet","paymentOrder":"paymentOrder","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Admission":"afb7f26a","Applicant":"f20697e3","DataApp":"09ccb9a1","Employee":"d892ea41","Exam":"8d062c9e","ForgetPassword":"3133c6c5","Mail":"d08be5c9","MyApplication":"8280e7aa","NotFound":"61ad64ef","Profile":"c490c560","Tasks":"435a5de0","Trems":"c1f2fde6","Wallet":"9384c4ea","chunk-06cee362":"95d9025d","chunk-12600c3a":"49ce8f41","chunk-177cef20":"656cd7d5","chunk-1d0392c0":"1b180b2c","chunk-1e0522c4":"5f19f683","chunk-2575000c":"dd60c3a4","chunk-26510dc2":"9fb6abb9","chunk-2f201d70":"afdaa272","chunk-49307dee":"82b25ce8","chunk-49f492f6":"ad5e9373","chunk-56e7897d":"8b73ba31","chunk-0a286c4a":"7134d7b8","chunk-2698ca9a":"146045b0","chunk-72e4370c":"d2e63272","chunk-745434a2":"8b26dcd0","chunk-75104e07":"5753914a","chunk-7b70d74c":"93e6f93c","chunk-d85ec124":"84ea62b3","chunk-2d0d8399":"10d7132e","chunk-40f4a996":"785c83d6","chunk-ef423c1c":"f2fc93c1","paymentOrder":"b70057c7","welcome":"108a774a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Applicant":1,"DataApp":1,"Exam":1,"ForgetPassword":1,"Mail":1,"MyApplication":1,"NotFound":1,"Profile":1,"Tasks":1,"Trems":1,"Wallet":1,"chunk-06cee362":1,"chunk-12600c3a":1,"chunk-177cef20":1,"chunk-1d0392c0":1,"chunk-1e0522c4":1,"chunk-2575000c":1,"chunk-26510dc2":1,"chunk-2f201d70":1,"chunk-49307dee":1,"chunk-49f492f6":1,"chunk-0a286c4a":1,"chunk-2698ca9a":1,"chunk-72e4370c":1,"chunk-745434a2":1,"chunk-75104e07":1,"chunk-7b70d74c":1,"chunk-d85ec124":1,"chunk-40f4a996":1,"chunk-ef423c1c":1,"paymentOrder":1,"welcome":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Admission":"Admission","Applicant":"Applicant","DataApp":"DataApp","Employee":"Employee","Exam":"Exam","ForgetPassword":"ForgetPassword","Mail":"Mail","MyApplication":"MyApplication","NotFound":"NotFound","Profile":"Profile","Tasks":"Tasks","Trems":"Trems","Wallet":"Wallet","paymentOrder":"paymentOrder","welcome":"welcome"}[chunkId]||chunkId) + "." + {"Admission":"31d6cfe0","Applicant":"cc655c51","DataApp":"85d9f3fd","Employee":"31d6cfe0","Exam":"f8033745","ForgetPassword":"8fb231b8","Mail":"dd9e5943","MyApplication":"b04cacbd","NotFound":"e9a32cfd","Profile":"b0eabc75","Tasks":"7cb9ab78","Trems":"d83177a5","Wallet":"2d651792","chunk-06cee362":"cc39f9ee","chunk-12600c3a":"a6bd095f","chunk-177cef20":"3422ef7d","chunk-1d0392c0":"2450304e","chunk-1e0522c4":"99acf092","chunk-2575000c":"7d25d397","chunk-26510dc2":"0217ce13","chunk-2f201d70":"3b31de4a","chunk-49307dee":"7025004f","chunk-49f492f6":"721a0347","chunk-56e7897d":"31d6cfe0","chunk-0a286c4a":"78aa6ba1","chunk-2698ca9a":"f1ec96db","chunk-72e4370c":"fa293758","chunk-745434a2":"a8712016","chunk-75104e07":"7025004f","chunk-7b70d74c":"22a2b72d","chunk-d85ec124":"2450304e","chunk-2d0d8399":"31d6cfe0","chunk-40f4a996":"b3daf986","chunk-ef423c1c":"83eddce8","paymentOrder":"04620838","welcome":"0dba3f93"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
